import axios from '../../axios'

/*
 * 投档数据管理接口
 */

// 创建投档信息
export const createTDInfo = (data) => {
    return axios({
        url: '/api/data/wish/archive',
        method: 'POST',
        data
    })
}

// 获取投档信息
export const getTDInfo = (data) => {
    return axios({
        url: '/api/data/wish/archive/info',
        method: 'GET',
        data
    })
}

// 修改投档信息
export const editTDInfo = (data) => {
    return axios({
        url: '/api/data/wish/archive',
        method: 'PUT',
        data
    })
}

// 删除投档信息
export const deleteTDInfo = (data) => {
    return axios({
        url: '/api/data/wish/archive',
        method: 'DELETE',
        data
    })
}

// 获取投档信息列表
export const getTDInfoList = (data) => {
    return axios({
        url: '/api/data/wish/archive',
        method: 'GET',
        data
    })
}

// 根据关键词模糊搜索投档信息列表
export const searchByKey = (data) => {
    return axios({
        url: '/api/data/wish/search/archive/page',
        method: 'GET',
        data
    })
}

// 投档数据导入功能
export const importTData = (data) => {
    return axios({
        url: '/api/data/wish/archive/import',
        method: 'POST',
        data
    })
}

// 投档数据导出功能
export const exportTData = (data) => {
    return axios({
        url: '/api/data/wish/archive/export',
        method: 'POST',
        data
    })
}

// 投档数据批量更新功能
export const updataTData = (data) => {
    return axios({
        url: '/api/data/wish/archive/batch/update',
        method: 'POST',
        data
    })
}

// 投档数据批量删除功能
export const quertDelData = (data) => {
    return axios({
        url: '/api/data/wish/archive/batch/delete',
        method: 'POST',
        data
    })
}

// 招录数据根据投档最低分对比并标记大小年后导出
export const querySmallyear = data => {
    return axios({
        url: '/api/data/wish/archive/small/year/diff/export/v2',
        method: 'POST',
        data
    })
}

// 一键同步院校投档分
export const archiveSync = data => {
    return axios({
        url: '/api/data/wish/archive/sync',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/tdInfo.js